/**
 * What clicking an install button does: open the agent through its own install link,
 * or copy what the user pastes into an agent that has no install link.
 */
export enum AgentInstallActionEnum {
  OPEN_INSTALL_LINK = "open-install-link",
  COPY_INSTALL_TEXT = "copy-install-text",
}
